<template>
  <MyAccount />
</template>

<script>
import MyAccount from '../components/MyAccount'

export default {
  components: {
    MyAccount
  }
}
</script>
